import React, {
  createContext,
  SetStateAction,
  Dispatch,
  useContext,
  useMemo,
  useState
} from 'react';
import { SortOrder } from 'graphql/types';

type NotesSortContextType = {
  sortOrder: SortOrder;
  setSortOrder: Dispatch<SetStateAction<SortOrder>>;
};

export const NotesSortContext = createContext<NotesSortContextType>({
  sortOrder: SortOrder.Descending,
  setSortOrder: () => {}
});

export const useNotesSortContext = (): NotesSortContextType =>
  useContext(NotesSortContext);

const NotesSortContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [sortOrder, setSortOrder] = useState(SortOrder.Descending);
  const value = useMemo(() => {
    return {
      sortOrder,
      setSortOrder
    };
  }, [sortOrder, setSortOrder]);

  return (
    <NotesSortContext.Provider value={value}>
      {children}
    </NotesSortContext.Provider>
  );
};

export default NotesSortContextProvider;
